<template>
<div>
  <form-welcome-modal-dialog 
    :editID="editID"
    :showDialog="showDialog"
    :onGetData="getModalData"
    :onClose="() => {editID = null}"
  />
  <custom-table
      icon="mdi-sticker-alert"
      title="settings.welcomeModal.title"
      :headers="[{
          text: $t('settings.welcomeModal.name'),
          align: 'left',
          sortable: false,
          value: 'ident',
        },
        {
          text: $t('settings.welcomeModal.preview'),
          align: 'center',
          sortable: false,
          value: 'preview',
        },
        {
          text: $t('settings.welcomeModal.hide'),
          align: 'center',
          sortable: false,
          value: 'hide',
        },
        {
          text: $t('settings.welcomeModal.remember'),
          align: 'center',
          sortable: false,
          value: 'remember',
        },
        {
          text: '',
          sortable: false,
          value: 'log',
        },
      ]"
      :data="data"
      :count="count"
      :loading="loading"
      :onAdd="handleAdd"
      :color="enterpriseColor"
      :isWelcomeModal="true"
      :itemsPerPage="100000"
    />
</div>
</template>

<script>
  import { mapState } from 'vuex'
  import api from '@/services/api'
  import utils from '@/services/utils.js'
  import CustomTable from '@/components/CustomTable'
  import FormWelcomeModalDialog from './FormWelcomeModalDialog'
  export default {
    components: {
      FormWelcomeModalDialog,
      CustomTable
    },
    props: {
    },
    data: () => ({
      editID: null,
      showDialog: false,
      loading: false,
      search: '',
      data: [],
      count: 0,
    }),
    computed: {
      ...mapState('app',['Languages', 'enterpriseID', 'BGColor', 'Logo', 'Carousel', 'enterpriseColor', 'Languages', 'DefaultLocale']),
      allLanguages () {
        return utils.getAllLanguages()
      }
    },
    watch: {
    },
    mounted () {
      this.getModalData()
    },
    methods: {
      handleAdd () {
        this.handleEdit(null)
      },
      handleEdit(id){
        this.editID = id
        if (this.showDialog) {
          this.showDialog = false
          setTimeout(() => {
            this.showDialog = true
          }, 500)
        } else this.showDialog = true
      },
      getModalData () {
        this.editID = null
        this.loading = true
        api.getAll(`enterprises/welcome-modal/${utils.getEnterpiseID()}/`, true, 1, 100000, '').then(response => {
          if (response.data) {
            this.data = response.data.filter(x => x.ID).map((item, index) => {
              item.Name = item.Name && item.Name.length > 0 ? item.Name : ' - '
              return ({
                ident: {
                  id: item.ID,
                  name: item.Name && item.Name.length > 0 ? item.Name : item.ID,
                  onClick: this.handleEdit
                },
                ID: item.ID,
                index,
                hide: item.Hide ? true : false,
                remember: item.Remember ? true : false,
                previewURL: 'http://demo.dtouch.local:8081?fm=true&previewID='.concat(item.ID),
                log: {
                  cd: item.CD,
                  lmd: item.LMD,
                },
                // domain: item.Domain,
                // action: {
                //   id: item.ID
                // }
              })
            })
          } else this.data = []
          this.count = response.count
          this.loading = false
        })
      },      
    },
  }
</script>
